import * as React from "react";

function GithubIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 56a4 4 0 0 0 4-4 8 8 0 0 1 2.35-5.67s-13.69-1.53-16.6-7.41A21.67 21.67 0 0 1 8 29.42 17.23 17.23 0 0 1 11.9 18a15.43 15.43 0 0 1-.77-4.82C11.13 11 11 10 12 8c4.48 0 8 .85 11.37 3.52A39.58 39.58 0 0 1 32 10.7a39.58 39.58 0 0 1 8.63.82C44 8.85 47.52 8 52 8c1 1.95.87 3 .87 5.18A15.43 15.43 0 0 1 52.1 18 17.23 17.23 0 0 1 56 29.42a21.67 21.67 0 0 1-1.75 9.5c-2.91 5.88-16.6 7.41-16.6 7.41A8 8 0 0 1 40 52a4 4 0 0 0 4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 50.88c-4 2-6.31-.43-8.75-2S11 46.75 8 48"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.81,
    cy: 31.72,
    rx: 3.19,
    ry: 4.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.19,
    cy: 31.72,
    rx: 3.19,
    ry: 4.82
  }));
}

export default GithubIcon;